module.exports = __webpack_public_path__ + "static/media/background2.f387ab5c.jpg";